<template>
    <div>

<section class="header-section" style="">
        <!-- <img src="{{ url('images/ic_tally_background.png') }}" style="position: absolute;" class="img-fluid" width="1020" > -->
       

        <div style="margin-top: -20px; height: 14px; background-color: #FFC132;">

        </div>
        <!-- <img src="{{ url('images/ic_tally_line_background.png') }}" class="img-fluid" style="position: absolute; z-index: -1" width="80%" height="50%"> -->
        <div class="container " style="">

            <!--     <div class="col-lg-6 col-md-6">
 <h1 class="text-left" style="line-height: 3.5vw;"><span style="font-size: 3.8vw;">Growing your business</span> <br>
    <span style="font-weight: bold; font-size: 4.9vw;" class="top-heading-second-line">
 is your top priority</span></h1>
    </div>
<div class="col-lg-6 col-md-6 mt-5 text-right">

    <img src="{{ url('images/tally_overview.jpg') }}" class="img-fluid" width="500" height="500">    

    </div> -->


            <div class="container">
                <div class="text-center">

                    <!-- 
  <img src="{{ url('images/ic_tally_prime_logo.png') }}" class="img-fluid" width="220" height="220">  -->
                </div>
                <!-- 
<h6 class="text-center " style="font-weight: bold;color:#282923">
EXTRAORDINARILY SIMPLE | DELIGHTFULLY FLEXIBLE | INCREDIBLY INSIGHTFUL
</h6>
 -->
                <br>
                <div class="row">
                    <div class="col-lg-6">
                        <!--  <h1 class="" style="font-weight: bold; font-size: 200%; color:#3069B1">
#MakeEveryDaySimple
</h1> -->
                        <!-- <p class="" style="font-size: 150%;">
    with the all new business management solution.
</p> -->
                    </div>
                    <div class="col-lg-6">
                        <!--         <h4 class="text-right display-4" style="color: #3B5897; font-weight: bold;">
                Inspired by you.
                <br>
                Designed to delight you.
            </h4>
     -->
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-4">
                        <img v-bind:src="'../imgs/ic_tally_prime_logo.png'" class="img-fluid tally-header-img"
                            width="320" height="320">
                    </div>
                    <div class="col-lg-8 text-right">
                        <h1 class="" style="font-weight: bold; font-size: 200%; color:#3069B1">
                            #MakeEveryDaySimple
                        </h1>
                        <p class="" style="font-size: 150%;">
                            with the all new business management solution.
                        </p>

                        <h4 class="text-right display-4" style="color: #3B5897; font-weight: bold;">
                            Experience the
                            <br>
                            Power Of Cloud
                        </h4>

                    </div>

                </div>
            </div>

            <!-- <br>


<h6 class="text-center" style="font-weight: bold; font-size: 200%; color:#3069B1">
A software that understands you, <br> and manages &amp; simplifies your business
</h6> -->

        </div>
        <div style="margin-top: 24px; height: 14px; background-color: #3068B2;">

        </div>
        <div class="text-center">
            <!-- Below is only a horizontal line -->
            <!-- <div style="background-color: #F1F1F1; width: 80%; height: 1px; display: inline-block;">
    
  </div> -->
        </div>
    </section>
    
    <section>
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 mt-4">
            <h2 class="text-center" style="font-weight: bold; color:#3069B3;">What is Tally?</h2>

            <p class="text-center" style="padding-left: 40px; padding-right: 40px;">
                Tally Solutions Pvt. Ltd. is a pioneer in the business software products areana. Since its inception in
                1989, Tally's simple yet powerful products have been revolutionizing the way business run. Having
                delivered path breaking technology consistently for more than 30 years, Tally symbolizes unmatched
                innovation and leadership. Today, it caters to millions of users across inductries in over 100 contries
                and continues to be the unchallenged industry leader in the enterprise resource pladding software
                domain.
            </p>

            <br>
            <br>

        </div>
    </section>

    <br>
    <br>

    <section>
        <main>
            <article id="second">
                <div id="article-bg"></div>
                <div class="container" style="z-index: 10;">
                    <h4 class="text-center display-3">Do more with Tally Cloud</h4>
                    <section>
                        <br>
                        <br>
                        <div class="container">
                            <div class="row">
                                <div class="col-lg-6 col-xs-12">
                                    <img src="https://resources.tallysolutions.com/wp-content/uploads/2020/tallyprime/TP-feature1.svg"
                                        class="img-fluid about-img shadow" width="500" height="500">
                                </div>
                                <div class="col-lg-6 col-xs-12" style="margin: auto;">
                                    <p style="color: #ffffff; font-size: 18px; " class="">TallyPrime's Go-To and
                                        Switch-To capability helps you discover and get more out of TallyPrime. It will
                                        help you discover new insights to run your business better. It also helps you
                                        multi task better, moving from report to another without forgetting what you
                                        were doing.</p>
                                </div>
                            </div>

                            <br>
                            <br>
                            <div class="row">
                                <div class="col-lg-6 col-xs-12" style=" margin: auto;">
                                    <p style="color: #ffffff; font-size: 18px; " class="">Our magical reporting engine
                                        gets even more insightful with Change-View, Basis-of-Values and
                                        Exception-Reports, that you'll find across the product.</p>
                                    <li>Change-View suggests alternative views of the same report to get better insights
                                    </li>
                                    <li>Basis-of-Values changes the parameters in the reports to provide a different
                                        perspective</li>
                                    <li>
                                        Exception-Reports highlights data in the reports that you should know that
                                        stands out
                                    </li>


                                </div>
                                <div class="col-lg-6 col-xs-12">
                                    <img src="https://resources.tallysolutions.com/wp-content/uploads/2020/tallyprime/TP-feature2.svg"
                                        class="img-fluid about-img shadow" width="500" height="500">
                                </div>
                            </div>
                            <br>
                            <br>
                            <div class="row">
                                <div class="col-lg-6 col-xs-12">
                                    <img src="https://resources.tallysolutions.com/wp-content/uploads/2020/tallyprime/TP-feature3.svg"
                                        class="img-fluid about-img shadow" width="500" height="500">
                                </div>
                                <div class="col-lg-6 col-xs-12" style=" margin: auto;">
                                    <p style="color: #ffffff; font-size: 18px; " class="">Our data entry and recording
                                        experiences are now dramatically simpler - really moulding Tally to your
                                        business. Our new More-Details capability allows you to handle all sorts of
                                        situations you are hit in your business everyday. With our new Top-Bar and
                                        Right-Bar, you will not just be able to simply move to the new TallyPrime
                                        without any hesitation, you'll not be able to imagine life without it.</p>
                                </div>
                            </div>
                        </div>
                    </section>

                </div>
            </article>
            <article>
            </article>
        </main>
    </section>

    <br>
    <br>
    <br>
    <br>

    <section>
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 mt-4">
            <h4 class="text-center display-3">Features of Tally Cloud</h4>
                <div class="grid grid-cols-4 gap-2">    
                    <div class="rounded border p-2">
                        <i class="fas fa-business-time text-3xl"></i> <br>
                        <span class="text-lg font-weight-bold">Access Anytime</span>
                    </div>

                    <div class="rounded border p-2">
                        <i class="fas fa-globe-asia text-3xl"></i><br>
                        <span class="text-lg font-weight-bold">Access from Anywhere</span>
                    </div>
                    <div class="rounded border p-2">
                        <i class="fas fa-print text-3xl"></i><br>
                        <span class="text-lg font-weight-bold">Accessibility with local printers</span>
                    </div>
                    <div class="rounded border p-2">
                        <i class="fas fa-headset text-3xl"></i><br>
                        <span class="text-lg font-weight-bold">Customized Support</span>
                    </div>
                    <div class="rounded border p-2">
                        <i class="fas fa-user text-3xl"></i><br>
                        <span class="text-lg font-weight-bold">User Friendly</span>
                    </div>
                    <div class="rounded border p-2">
                        <i class="fas fa-tachometer-alt text-3xl"></i><br>
                        <span class="text-lg font-weight-bold">High Performance &amp; Light weight</span>
                    </div>
                    
                </div>
        </div>
    </section>
<br><br>
<br>
<br>
    <section>
        <div class="container">
            <h4 class="text-center display-3">Why >2 million Businesses trust Tally?</h4>
            <br>
            <div class="trust-container row">
                <div class="box">
                    <div class="boxContent">
                        <!-- <i class="fa fa-shield-alt icon"></i> -->
                        <i class="las la-shield-alt icon"></i>
                        <h1 class="title">Safe Business Data</h1>
                        <p class="desc">Your business data is always safe and secure. You may encounter difficult
                            conditions, such as computer issue, or other software issues, but nothing of your data will
                            be hampered. We have also taken care such that even in the most vulnerable situation no one
                            else other than You can access your data.</p>
                    </div>
                    <a href="#"></a>
                </div>
                <div class="box">
                    <div class="boxContent">
                        <i class="las la-headset icon"></i>
                        <h1 class="title">Real, human support</h1>
                        <p class="desc">TallyPrime has been designed such that you will rarely need any support or help
                            in running the product. In case you do need help, you can use in-product help to solve it
                            yourself or directly reach us on call/mail. And with no IVR, you get instant assistance from
                            a Tally expert, free of cost, for lifetime.</p>
                    </div>
                    <a href="#"></a>
                </div>
                <div class="box">
                    <div class="boxContent">

                        <i class="las la-chart-bar icon"></i>
                        <h1 class="title">Future Ready</h1>
                        <p class="desc">Change is inevitable. Hence, we ensure that irrespective of the nature of the
                            change, be it statutory or technological, we always bring you the latest updates. So that
                            your business keeps functioning as smooth as always.</p>
                    </div>
                    <a href="#"></a>
                </div>
            </div>

        </div>
    </section>
    <br>
    <br>
    <section>
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 mt-4 text-center">
            <h2 class="text-center display-3">Benefits of Tally On Cloud</h2>
            <div class="grid grid-cols-4 gap-2 text-white">    
                <div class="rounded shadow p-2" style="background-color:#396ABB">
                    <i class="fas fa-code-branch text-xl"></i>
                    <br>
                    <span class="text-lg font-weight-bold">Centralized</span>
                    <br>
                    <span class="text-sm">Centralised data access from anywhere-anytime-anydevice</span>
                </div>
                <div class="rounded shadow p-2" style="background-color:#396ABB">
                    <i class="fas fa-user-secret text-xl"></i>
                    <br>
                    <span class="text-lg font-weight-bold">Security</span>
                    <br>
                    <span class="text-sm">Advanced data security and data privacy.</span>
                </div>
                <div class="rounded shadow p-2" style="background-color:#396ABB">
                    <i class="fas fa-crosshairs text-xl"></i>
                    <br>
                    <span class="text-lg font-weight-bold">Planning</span>
                    <br>
                    <span class="text-sm">Ease in planning, budgeting, forecasting and analyzing</span>
                </div>
                <div class="rounded shadow p-2" style="background-color:#396ABB">
                    <i class="fas fa-tachometer-alt text-xl"></i>
                    <br>
                    <span class="text-lg font-weight-bold">Speed</span>
                    <br>
                    <span class="text-sm">High speed access to your servers and data.</span>
                </div>
                
            </div>
        </div>
    </section>
    <br>
    <br>
    

    <section style="background-color: #F3F3F3" class="pt-4">
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 mt-4 text-center">
            <h2 class="text-center" style="font-weight: bold;">Tally Products</h2>
            <div class="row pb-5 mb-5 pt-4">
                <div class="col-lg-4 col-md-6 our-product-box">
                    <h2 class="product-name" style="text-align: left;">TallyPrime</h2>
                    <p style="text-align: left;">The all new Powerful Business Management software for small and medium
                        enterprises</p>
                </div>
                <div class="col-lg-4 col-md-6 our-product-box">
                    <h2 class="product-name" style="text-align: left;">TallyPrime Server</h2>
                    <p style="text-align: left;">Enterprise Class Product for your growing Business</p>
                </div>
                <div class="col-lg-4 col-md-6 our-product-box">
                    <h2 class="product-name" style="text-align: left;">Tally Software Services (TSS)</h2>
                    <p style="text-align: left;">Integrated software solution for small and medium enterprises</p>
                </div>
            </div>
        </div>
    </section>
    <section style="background-color: #A0CDEC;">
        <br>
        <br>
        <div class="container text-center">
            <h4 class="display-4" style="font-weight: bold;">Still in Doubt?</h4>
            <p class="lead">Sign up for a 7-day free trial before you take a decision – we’re sure you’ll fall in love
                with the product!</p>

            <br>
            <div class="text-center">
                <a href="https://tallysolutions.com/business-software-7day-free-trial/?strCampaignID=918"
                    style="text-decoration: none;" class="text-center"><button class="pro-dwld-btn text-center"
                        style=" color:#333333; background: #FFC632;">Take a Free Trial</button>
                </a>
            </div>
        </div>
        <br>
        <br>
    </section>


    <section>
        <div class="container mt-5">
            <h2 class="text-center" style="font-weight: bold;">Videos</h2>
            <div class="grid grid-cols-2 gap-1 mt-5 mb-5 text-center">

                <div class="">

                    <iframe width="100%" height="100%" src="https://www.youtube.com/embed/ZhWCmqRzO04" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>

                    <!--  <iframe width="80%" height="100%" src="https://www.youtube.com/embed/OItO9XwgHlI" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen class="frame-youtube"></iframe> -->
                </div>

                <div class="">

                    <iframe width="100%" height="100%" src="https://www.youtube.com/embed/Ow6NXj3PzBo" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>

                    <!--  <iframe width="80%" height="100%" src="https://www.youtube.com/embed/1LBFQTyLmLg" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen class="frame-youtube"></iframe>
 -->
                </div>

            </div>


        </div>
    </section>

    </div>
</template>


<script type="application/javascript">
import { Head, Link } from '@inertiajs/inertia-vue3';
import JetNavLink from '@/Jetstream/NavLink.vue'

// import $ from 'jquery';

    export default {
       components:{
         JetNavLink,
        },
        props: {
            canLogin: Boolean,
            canRegister: Boolean,

            // prod_id:string,
        },
         data() {
        return {
            canRegister:true,
            // url: '', 
        }
    },
      mounted() {
          const typedTextSpan = document.querySelector(".typed-text");
    const cursorSpan = document.querySelector(".cursor");
   console.log(cursorSpan)
    const textArray = ["hard", "fun", "a journey", "LIFE"];
    const typingDelay = 200;
    const erasingDelay = 100;
    const newTextDelay = 2000; // Delay between current and next text
    let textArrayIndex = 0;
    let charIndex = 0;

    function type() {
        if (charIndex < textArray[textArrayIndex].length) {
            if (!cursorSpan.classList.contains("typing")) cursorSpan.classList.add("typing");
            typedTextSpan.textContent += textArray[textArrayIndex].charAt(charIndex);
            charIndex++;
            setTimeout(type, typingDelay);
        } else {
            cursorSpan.classList.remove("typing");
            setTimeout(erase, newTextDelay);
        }
    }

    function erase() {
        if (charIndex > 0) {
            if (!cursorSpan.classList.contains("typing")) cursorSpan.classList.add("typing");
            typedTextSpan.textContent = textArray[textArrayIndex].substring(0, charIndex - 1);
            charIndex--;
            setTimeout(erase, erasingDelay);
        } else {
            cursorSpan.classList.remove("typing");
            textArrayIndex++;
            if (textArrayIndex >= textArray.length) textArrayIndex = 0;
            setTimeout(type, typingDelay + 1100);
        }
    }

    document.addEventListener("DOMContentLoaded", function() { // On DOM Load initiate the effect
        if (textArray.length) setTimeout(type, newTextDelay + 250);
    });
    
    }
    }
  
    
</script>

<style scoped>
 a:hover{
        text-decoration: none;
    }
.img_size{
    height: auto;
    width: 156px;
}
:root {
        --blue: #0068CA;
        --white: #ffffff;
        --primary: #82C5FF;
        --secondary: #FDC031;
        --black: #333333;
        --input_grey: #d7d7d7;
        --hint_grey: #bfbfbf;
        --pink: #FF4B69;
    }

    * {
        outline: none;
    }

    /*Scroll - START*/
    /* width */
    ::-webkit-scrollbar {
        width: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #888;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

    /*Scroll - END*/
 .top-heading-second-line {
            text-shadow: 2px 2px 8px #365862;
            transition: 0.3s;
        }

        .top-heading-second-line:hover {
            text-shadow: 2px 2px 8px #00DFC0;
        }

        .header-section {
            margin-top: -20px;
            /*background-image:url({{'images/ic_tally_background.png' }});
            background-repeat: no-repeat;
            background-size: contain;*/

        }

                        /* Extra small devices (phones, 600px and down) */
                @media only screen and (max-width: 600px) {
                    .tally-header-img {
                        position: relative;
                        left: 10%;
                        right: 10%;
                    }

                }

                /* Small devices (portrait tablets and large phones, 600px and up) */
                @media only screen and (min-width: 600px) {
                    .tally-header-img {
                        position: relative;
                        left: 5%;
                        right: 10%;
                    }
                }

                /* Medium devices (landscape tablets, 768px and up) */
                @media only screen and (min-width: 768px) {
                    .tally-header-img {
                        position: relative;
                        left: 20%;
                        right: 20%;
                    }
                }

                /* Large devices (laptops/desktops, 992px and up) */
                @media only screen and (min-width: 992px) {
                    .tally-header-img {
                        position: relative;
                        top: 35%;
                        bottom: 35%;
                    }
                }

                /* Extra large devices (large laptops and desktops, 1200px and up) */
                @media only screen and (min-width: 1200px) {
                    .tally-header-img {
                        position: relative;
                        top: 35%;
                        bottom: 35%;
                    }

                }

                            .unlock {
                font-size: 7.9vh;
                margin-right: 12vw;
                color: #00DBBC;
            }

            .your {
                font-size: 4.0vh;
                margin-left: 35px;

            }

            .business {
                font-size: 5.2vh;
                margin-left: 48px;
                line-height: 40px;
            }

            .true {
                font-size: 6.5vh;
                font-weight: bolder;
            }

            .potential {
                font-size: 6.5vh;

            }

            .tally-erp-9 {
                font-size: 7.9vh;
                color: #008C74;
                font-weight: bolder;
            }

            .with {
                font-size: 3.5vh;
                font-weight: bolder;
            }

    main article#second {
        position: relative;
        display: -webkit-box;
        display: flex;
        -webkit-box-pack: center;
        justify-content: center;
        padding: 5rem 0 6rem 0;
        color: #fafafa;
    }

    main article#second #article-bg {
        position: absolute;
        top: 0px;
        bottom: 0;
        right: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(150deg, #5e7ce2 10%, #3066B1);
        -webkit-transform: skewY(-2deg);
        transform: skewY(-2deg);
        -webkit-transform-origin: top right;
        transform-origin: top right;
    }

    main article#second h1 {
        position: relative;
    }

    @media (max-width: 30rem) {
        ul {
            text-align: center;
            flex-wrap: wrap;
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
            flex-direction: column;
        }
    }
                        .about-img {
                            border-radius: 10px;
                        }
        /* Variables */
        /* Mixins */
        .trust-container {
            -webkit-box-pack: space-evenly;
            justify-content: space-evenly;
            -webkit-box-align: center;
            align-items: center;

        }

        .trust-container .box {
            width: 250px;
            height: 420px;
            border-radius: 10px;
            background-color: white;
            margin: 20px;
            -webkit-transition: .3s all ease-in-out;
            transition: .3s all ease-in-out;
            position: relative;
            box-shadow: 0px 0px 15px background;
            /* Link */
        }

        .trust-container .box .boxContent {
            display: -webkit-box;
            display: flex;
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
            flex-direction: column;
            -webkit-box-pack: center;
            justify-content: center;
            -webkit-box-align: center;
            align-items: center;
            text-align: center;
            padding: 15px;
        }

        .trust-container .box .boxContent .icon {
            color: #3A6BBB;
            font-size: 48px;
            padding: 15px;
        }

        .trust-container .box .boxContent .title {
            font-size: 24px;
            color: #3A6BBB;
            font-weight: bold;
            padding: 10px;
        }

        .trust-container .box .boxContent .desc {
            color: #3A6BBB;
            font-size: 15px;
            height: 20%;
        }

        .trust-container .box a {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
        }

        .trust-container .box:hover {
            background: linear-gradient(130deg, #503bff 0%, #3A6BBB 100%);
            box-shadow: none;
        }

        .trust-container .box:hover .icon,
        .trust-container .box:hover .title,
        .trust-container .box:hover .desc {
            color: white;
            -webkit-transition: .3s all ease-in-out;
            transition: .3s all ease-in-out;
        }

                .product-name {
            color: #3068B2;
            font-weight: bold;
        }

        .our-product-box {
            border: 1px solid #CECECE;
            margin-top: 5px;
        }

    .pro-dwld-btn {
        border-radius: 10px;
        padding: 10px;
        border: 0px solid #000000;
        color: #ffffff;
        font-weight: bold;
        margin-bottom: 10px;
    }
        .frame-youtube {
            text-align: center;

        }



</style>

